import { TProjectConfigurationParameter } from 'entries/common/widgets/context';

export const parseProjectConfiguration = (
  projectConfigurationParameters: Array<TProjectConfigurationParameter>
): { [key: string]: string } => {
  const params: { [key: string]: string } = {};
  projectConfigurationParameters.forEach(({ key, value }) => {
    if (key === 'layingType') {
      params.thickness = value;
    } else {
      params[key] = value;
    }
  });

  return params;
};
